import { useSavingsWithdrawDialog } from './logic/useSavingsWithdrawDialog'
import { Mode } from './types'
import { SavingsWithdrawView } from './views/SavingsWithdrawView'
import { SuccessView } from './views/SuccessView'
import { Token } from '@/domain/types/Token'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface SavingsWithdrawContainerProps {
  closeDialog: () => void
  mode: Mode
  savingsToken: Token
  chainId: number
}

function SavingsWithdrawDialogContentContainer({
  closeDialog,
  mode,
  savingsToken,
  chainId,
}: SavingsWithdrawContainerProps) {
  const {
    selectableAssets,
    assetsFields,
    form,
    tokenToWithdraw,
    pageStatus,
    txOverview,
    sendModeExtension,
    accountName,
    renderWithdrawValidationError,
    actionsViewState,
  } = useSavingsWithdrawDialog({ mode, savingsToken, chainId })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView tokenToWithdraw={tokenToWithdraw} closeDialog={closeDialog} sendModeExtension={sendModeExtension} />
    )
  }

  return (
    <SavingsWithdrawView
      accountName={accountName}
      form={form}
      selectableAssets={selectableAssets}
      assetsFields={assetsFields}
      txOverview={txOverview}
      actionsViewState={actionsViewState}
      sendModeExtension={sendModeExtension}
      renderError={renderWithdrawValidationError}
    />
  )
}

const SavingsWithdrawDialogContentContainerWithSuspense = withSuspense(
  SavingsWithdrawDialogContentContainer,
  DialogContentSkeleton,
)
export { SavingsWithdrawDialogContentContainerWithSuspense as SavingsWithdrawDialogContentContainer }
